import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import {
  MainCarousel,
  Gallery,
  News,
  Collaborators,
  TopCard,
  Introduction,
  Article,
  Notices,
  Press,
} from "./components";
import FundedBy from "./components/Fundedby.component";
import Disclaimer from "./components/Disclaimer.component";

// ACTIONs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getNewsAction,
  getEventAction,
  getPressAction,
  getDirectorsAction,
} from "../../actions/Actions";
import { FILE_URL } from "../../config/Api.config";

const HomePage = (props) => {
  const { setHeaderTitle, language } = useAuth();
  const {
    getEventAction,
    getPressAction,
    getDirectorsAction,
    news,
    event,
    press,
    teamMember,
  } = props;
  const { list: newsList } = news;
  const { list: pressList } = press;
  const { list: eventList } = event;
  const { directorList } = teamMember;

  useEffect(() => {
    setHeaderTitle(language.key.home);
  }, [setHeaderTitle, language.key.home]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getPressAction();
  }, [getPressAction]);

  useEffect(() => {
    getEventAction();
  }, [getEventAction]);

  useEffect(() => {
    getDirectorsAction();
  }, [getDirectorsAction]);

  return (
    <div>
      <div className="homepage">
        <MainCarousel />
        <div className="homepage-right">
          <div className="wrapper">
            {directorList?.length
              ? directorList.slice(0, 2).map((item, index) => {
                  return (
                    <div key={index} className="cards">
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${FILE_URL + item?.image})`,
                          backgroundPosition: "center",
                        }}></div>
                      <div className="information">
                        <div className="name">{item?.name}</div>
                        <div className="designation">{item?.designation}</div>
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
      <TopCard
        leftCard={<Notices />}
        rightCard={<Article data={eventList} />}
      />
      {/* {newsList && <News data={newsList} />} */}
      {pressList && <Press data={pressList} />}
      {/* <Collaborators /> */}
      <Gallery />
      {/* <FundedBy /> */}
      {/* <Disclaimer /> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    news: state.news,
    event: state.event,
    press: state.press,
    teamMember: state.teamMember,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getNewsAction,
      getEventAction,
      getPressAction,
      getDirectorsAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
